import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedModule } from '../shared/shared.module';
import { routes } from './landing.routes';
import { LandingComponent } from './landing/landing.component';
import { LandingHeaderComponent } from './header/header.component';
import { LandingHeroSectionComponent } from './landing/hero/hero.component';
import { LandingFlowSectionComponent } from './landing/flow/flow.component';
import { LandingThemesSectionComponent } from './landing/themes/themes.component';
import { LandingFooterComponent } from './footer/footer.component';
import { LandingRootComponent } from './landing-root/landing-root.component';
import { HowItWorksModule } from './how-it-works/how-it-works.module';
import { LandingStartUsingBarComponent } from './landing/start-using-bar/start-using-bar.component';
import { LandingThemesService } from './landing/themes/themes.service';
import { ProductModule } from './product/product.module';
import { LandingFaqComponent } from './faq/faq.component';
import { MagicAiModule } from './magic-ai/magic-ai.module';
import { LandingSharedModule } from './landing-shared/landing-shared.module';
import { StyleguideComponent } from './styleguide/styleguide.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LandingCarouselComponent } from './landing/landing-carousel/landing-carousel.component';
import { PricingComponent } from './landing/pricing/pricing.component';
import { LandingPricingService } from './landing/landing-pricing.service';
import { AppConfigService } from 'app/services/app-config.service';

@NgModule({
  declarations: [
    LandingRootComponent,
    LandingComponent,
    LandingHeaderComponent,
    LandingHeroSectionComponent,
    LandingFlowSectionComponent,
    LandingThemesSectionComponent,
    LandingFooterComponent,
    LandingStartUsingBarComponent,
    LandingFaqComponent,
    TermsComponent,
    StyleguideComponent,
    PrivacyComponent,
    LandingCarouselComponent,
    PricingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    TranslateModule,
    SharedModule,
    LandingSharedModule,
    HowItWorksModule,
    AngularSvgIconModule,
    ProductModule,
    MagicAiModule
  ],
  providers: [
    LandingThemesService,
    LandingPricingService,
  ],
})
export class LandingModule {
  public static routes = routes;
}
